import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ButtonModule } from "primeng/button";
import { NavButton } from "../../../common/models/common.model";
import { AuthService } from "../../../common/services/auth.service";

@Component({
  standalone: true,
  selector: "vig-navbar",
  templateUrl: "./navbar.component.html",
  styleUrl: "./navbar.component.scss",
  imports: [CommonModule, ButtonModule],
})
export class NavbarComponent implements OnInit {
  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  items: NavButton[] = [];

  ngOnInit(): void {
    this.buildItems();

    // Subscribe to router changes and if any of the defined item urls matches the current route signal it active
    this.router.events.subscribe(() => {
      this.items.forEach((item) => {
        item.active = (item.url && this.router.url.startsWith(item.url)) || false;
      });
    });
  }

  buildItems(): void {
    this.items = [
      { label: "Home", icon: "home", url: "/admin/home" },
      { label: "Accounts", icon: "account_box", url: "/admin/accounts" },
      { label: "Channels", icon: "business", url: "/admin/orgs" },
      { label: "Members", icon: "group", url: "/admin/users" },
      { divider: true },
      {
        label: "Logout",
        icon: "logout",
        onClick: () => {
          this.authService.logout();
        },
      },
    ];
  }

  onItemClick(item: NavButton): void {
    if (item.url) {
      this.router.navigate([item.url]);
    } else if (item.onClick) {
      item.onClick();
    }
  }
}
